import { render, staticRenderFns } from "./ReportSubCollection.vue?vue&type=template&id=5f5455d4&"
import script from "./ReportSubCollection.vue?vue&type=script&lang=js&"
export * from "./ReportSubCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports